/* eslint-disable react/prefer-stateless-function */
import React from 'react';
// import { Tween } from 'react-gsap';

// const elementsArray = [
//   <linearGradient
//     id="SVGID_1_"
//     gradientUnits="userSpaceOnUse"
//     x1="439.4202"
//     y1="393.8734"
//     x2="577.6026"
//     y2="176.4667"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="0" style={{ stopColor: '#78B627' }} />
//     <stop offset="1" style={{ stopColor: '#3B8B31' }} />
//   </linearGradient>,
//   <polygon className="st0" points="706.4,829.2 448.9,978 448.9,680.5 " />,
//   <linearGradient
//     id="SVGID_2_"
//     gradientUnits="userSpaceOnUse"
//     x1="467.4291"
//     y1="643.8157"
//     x2="607.5806"
//     y2="427.743"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="0" style={{ stopColor: '#78B627' }} />
//     <stop offset="1" style={{ stopColor: '#3B8B31' }} />
//   </linearGradient>,
//   <polygon className="st1" points="706.4,531.7 448.9,680.5 448.9,383 " />,
//   <polygon className="st2" points="706.4,234.3 448.9,383 448.9,85.6 " />,
//   <polygon className="st2" points="706.4,-63.1 448.9,85.6 448.9,-211.9 " />,
//   <linearGradient
//     id="SVGID_3_"
//     gradientUnits="userSpaceOnUse"
//     x1="711.0189"
//     y1="541.5443"
//     x2="839.3254"
//     y2="318.0948"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="0" style={{ stopColor: '#78B627' }} />
//     <stop offset="1" style={{ stopColor: '#3B8B31' }} />
//   </linearGradient>,
//   <polygon className="st3" points="964.1,680.5 706.4,829.2 706.5,531.7 " />,
//   <polygon className="st4" points="448.9,680.5 706.4,531.7 706.4,829.2 " />,
//   <linearGradient
//     id="SVGID_4_"
//     gradientUnits="userSpaceOnUse"
//     x1="703.8817"
//     y1="838.7373"
//     x2="837.7382"
//     y2="618.5768"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="1.230000e-02" style={{ stopColor: '#99C219' }} />
//     <stop offset="1" style={{ stopColor: '#45A835' }} />
//   </linearGradient>,
//   <polygon className="st5" points="964.1,383 706.4,531.7 706.5,234.3 " />,
//   <polygon className="st6" points="448.9,383 706.4,234.3 706.4,531.7 " />,
//   <polygon className="st4" points="964.1,85.6 706.4,234.3 706.5,-63.1 " />,
//   <linearGradient
//     id="SVGID_5_"
//     gradientUnits="userSpaceOnUse"
//     x1="579.7471"
//     y1="1064.8811"
//     x2="701.868"
//     y2="838.0807"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="1.230000e-02" style={{ stopColor: '#99C219' }} />
//     <stop offset="1" style={{ stopColor: '#45A835' }} />
//   </linearGradient>,
//   <polygon className="st7" points="448.9,85.6 706.4,-63.1 706.4,234.3 " />,
//   <polygon className="st8" points="706.4,531.7 964.1,383 964,680.4 " />,
//   <linearGradient
//     id="SVGID_6_"
//     gradientUnits="userSpaceOnUse"
//     x1="834.1459"
//     y1="922.0588"
//     x2="966.238"
//     y2="700.8931"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="1.230000e-02" style={{ stopColor: '#00A5C3' }} />
//     <stop offset="1" style={{ stopColor: '#0084A9' }} />
//   </linearGradient>,
//   <polygon className="st9" points="706.4,234.2 964.1,85.5 964,383 " />,
//   <linearGradient
//     id="SVGID_7_"
//     gradientUnits="userSpaceOnUse"
//     x1="321.3548"
//     y1="1215.2065"
//     x2="446.1513"
//     y2="989.8256"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="1.230000e-02" style={{ stopColor: '#00A5C3' }} />
//     <stop offset="1" style={{ stopColor: '#0084A9' }} />
//   </linearGradient>,
//   <polygon className="st10" points="191.3,-63.2 448.9,-211.9 448.9,85.6 " />,
//   <polygon className="st8" points="191.3,234.3 448.9,85.6 448.9,383 " />,
//   <polygon className="st8" points="191.3,531.7 448.9,383 448.9,680.5 " />,
//   <polygon className="st4" points="191.3,829.2 448.9,680.5 448.9,978 " />,
//   <polygon className="st4" points="-66.3,85.6 191.3,-63.1 191.3,234.3 " />,
//   <polygon className="st11" points="448.9,85.6 191.3,234.3 191.3,-63.1 " />,
//   <polygon className="st8" points="-66.3,383 191.3,234.3 191.3,531.7 " />,
//   <linearGradient
//     id="SVGID_8_"
//     gradientUnits="userSpaceOnUse"
//     x1="191.26"
//     y1="696.99"
//     x2="448.86"
//     y2="696.99"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="1.230000e-02" style={{ stopColor: '#00A5C3' }} />
//     <stop offset="1" style={{ stopColor: '#0084A9' }} />
//   </linearGradient>,
//   <polygon className="st12" points="448.9,383 191.3,531.7 191.3,234.3 " />,
//   <polygon className="st4" points="-66.3,680.5 191.3,531.7 191.3,829.2 " />,
//   <polygon className="st2" points="448.9,680.5 191.3,829.2 191.3,531.7 " />,
//   <polygon className="st11" points="191.3,234.4 -66.3,383.1 -66.3,85.6 " />,
//   <polygon className="st11" points="191.3,531.9 -66.3,680.6 -66.3,383.1 " />,
//   <linearGradient
//     id="SVGID_9_"
//     gradientUnits="userSpaceOnUse"
//     x1="1469.7903"
//     y1="393.8734"
//     x2="1607.9727"
//     y2="176.4666"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="0" style={{ stopColor: '#78B627' }} />
//     <stop offset="1" style={{ stopColor: '#3B8B31' }} />
//   </linearGradient>,
//   <polygon className="st13" points="1736.8,829.2 1479.2,978 1479.2,680.5 " />,
//   <linearGradient
//     id="SVGID_10_"
//     gradientUnits="userSpaceOnUse"
//     x1="1497.7991"
//     y1="643.8156"
//     x2="1637.9507"
//     y2="427.7429"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="0" style={{ stopColor: '#78B627' }} />
//     <stop offset="1" style={{ stopColor: '#3B8B31' }} />
//   </linearGradient>,
//   <polygon className="st14" points="1736.8,531.7 1479.2,680.5 1479.2,383 " />,
//   <polygon className="st2" points="1736.8,234.3 1479.2,383 1479.2,85.6 " />,
//   <polygon className="st2" points="1736.8,-63.1 1479.2,85.6 1479.2,-211.9 " />,
//   <linearGradient
//     id="SVGID_11_"
//     gradientUnits="userSpaceOnUse"
//     x1="1741.3889"
//     y1="541.5443"
//     x2="1869.6954"
//     y2="318.0947"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="0" style={{ stopColor: '#78B627' }} />
//     <stop offset="1" style={{ stopColor: '#3B8B31' }} />
//   </linearGradient>,
//   <polygon className="st15" points="1994.5,680.5 1736.8,829.2 1736.9,531.7 " />,
//   <polygon className="st2" points="1479.2,680.5 1736.8,531.7 1736.8,829.2 " />,
//   <linearGradient
//     id="SVGID_12_"
//     gradientUnits="userSpaceOnUse"
//     x1="1734.2517"
//     y1="838.7372"
//     x2="1868.1083"
//     y2="618.5768"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="1.230000e-02" style={{ stopColor: '#99C219' }} />
//     <stop offset="1" style={{ stopColor: '#45A835' }} />
//   </linearGradient>,
//   <polygon className="st16" points="1994.5,383 1736.8,531.7 1736.9,234.3 " />,
//   <polygon className="st4" points="1479.2,383 1736.8,234.3 1736.8,531.7 " />,
//   <polygon className="st2" points="1994.5,85.6 1736.8,234.3 1736.9,-63.1 " />,
//   <linearGradient
//     id="SVGID_13_"
//     gradientUnits="userSpaceOnUse"
//     x1="1610.1171"
//     y1="1064.881"
//     x2="1732.238"
//     y2="838.0806"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="1.230000e-02" style={{ stopColor: '#00A5C3' }} />
//     <stop offset="1" style={{ stopColor: '#0084A9' }} />
//   </linearGradient>,
//   <polygon className="st17" points="1479.2,85.6 1736.8,-63.1 1736.8,234.3 " />,
//   <polygon className="st8" points="1736.8,531.7 1994.5,383 1994.4,680.4 " />,
//   <linearGradient
//     id="SVGID_14_"
//     gradientUnits="userSpaceOnUse"
//     x1="1864.516"
//     y1="922.0587"
//     x2="1996.6079"
//     y2="700.8931"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="1.230000e-02" style={{ stopColor: '#00A5C3' }} />
//     <stop offset="1" style={{ stopColor: '#0084A9' }} />
//   </linearGradient>,
//   <polygon className="st18" points="1736.8,234.2 1994.5,85.5 1994.4,383 " />,
//   <linearGradient
//     id="SVGID_15_"
//     gradientUnits="userSpaceOnUse"
//     x1="1226.8866"
//     y1="1143.165"
//     x2="1481.9368"
//     y2="1143.165"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="1.230000e-02" style={{ stopColor: '#00A5C3' }} />
//     <stop offset="1" style={{ stopColor: '#0084A9' }} />
//   </linearGradient>,
//   <polygon className="st19" points="1221.6,-63.2 1479.2,-211.9 1479.2,85.6 " />,
//   <polygon className="st8" points="1221.6,234.3 1479.2,85.6 1479.2,383 " />,
//   <polygon className="st8" points="1221.6,531.7 1479.2,383 1479.2,680.5 " />,
//   <polygon className="st4" points="1221.6,829.2 1479.2,680.5 1479.2,978 " />,
//   <linearGradient
//     id="SVGID_16_"
//     gradientUnits="userSpaceOnUse"
//     x1="964.03"
//     y1="994.41"
//     x2="1221.63"
//     y2="994.41"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="1.230000e-02" style={{ stopColor: '#99C219' }} />
//     <stop offset="1" style={{ stopColor: '#45A835' }} />
//   </linearGradient>,
//   <polygon className="st20" points="964,85.6 1221.6,-63.1 1221.6,234.3 " />,
//   <polygon className="st11" points="1479.2,85.6 1221.6,234.3 1221.6,-63.1 " />,
//   <polygon className="st8" points="964,383 1221.6,234.3 1221.6,531.7 " />,
//   <linearGradient
//     id="SVGID_17_"
//     gradientUnits="userSpaceOnUse"
//     x1="1221.63"
//     y1="696.99"
//     x2="1479.23"
//     y2="696.99"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="1.230000e-02" style={{ stopColor: '#00A5C3' }} />
//     <stop offset="1" style={{ stopColor: '#0084A9' }} />
//   </linearGradient>,
//   <polygon className="st21" points="1479.2,383 1221.6,531.7 1221.6,234.3 " />,
//   <polygon className="st4" points="964,680.5 1221.6,531.7 1221.6,829.2 " />,
//   <polygon className="st6" points="1479.2,680.5 1221.6,829.2 1221.6,531.7 " />,
//   <polygon className="st11" points="1221.6,234.4 964,383.1 964,85.6 " />,
//   <polygon className="st11" points="1221.6,531.9 964,680.6 964,383.1 " />,
//   <linearGradient
//     id="SVGID_18_"
//     gradientUnits="userSpaceOnUse"
//     x1="954.5568"
//     y1="1286.3086"
//     x2="1092.7393"
//     y2="1068.9019"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="0" style={{ stopColor: '#78B627' }} />
//     <stop offset="1" style={{ stopColor: '#3B8B31' }} />
//   </linearGradient>,
//   <polygon className="st22" points="1221.6,-63.2 964,85.5 964,-211.9 " />,
//   <linearGradient
//     id="SVGID_19_"
//     gradientUnits="userSpaceOnUse"
//     x1="706.4"
//     y1="1143.205"
//     x2="964"
//     y2="1143.205"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="0" style={{ stopColor: '#78B627' }} />
//     <stop offset="1" style={{ stopColor: '#3B8B31' }} />
//   </linearGradient>,
//   <polygon className="st23" points="706.4,-63.2 964,-211.9 964,85.5 " />,
//   <polygon className="st2" points="1221.6,1126.7 964,1275.4 964,977.9 " />,
//   <linearGradient
//     id="SVGID_20_"
//     gradientUnits="userSpaceOnUse"
//     x1="964"
//     y1="250.81"
//     x2="1221.5699"
//     y2="250.81"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="0" style={{ stopColor: '#78B627' }} />
//     <stop offset="1" style={{ stopColor: '#3B8B31' }} />
//   </linearGradient>,
//   <polygon className="st24" points="1221.6,829.2 964,977.9 964,680.5 " />,
//   <polygon className="st2" points="1479.3,977.9 1221.6,1126.7 1221.6,829.2 " />,
//   <linearGradient
//     id="SVGID_21_"
//     gradientUnits="userSpaceOnUse"
//     x1="1094.8872"
//     y1="172.5309"
//     x2="1217.0081"
//     y2="-54.2696"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="1.230000e-02" style={{ stopColor: '#00A5C3' }} />
//     <stop offset="1" style={{ stopColor: '#0084A9' }} />
//   </linearGradient>,
//   <polygon className="st25" points="964,977.9 1221.6,829.2 1221.6,1126.7 " />,
//   <linearGradient
//     id="SVGID_22_"
//     gradientUnits="userSpaceOnUse"
//     x1="1349.28"
//     y1="29.7053"
//     x2="1481.3719"
//     y2="-191.4603"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="1.230000e-02" style={{ stopColor: '#00A5C3' }} />
//     <stop offset="1" style={{ stopColor: '#0084A9' }} />
//   </linearGradient>,
//   <polygon
//     className="st26"
//     points="1221.6,1126.6 1479.3,977.8 1479.1,1275.3 "
//   />,
//   <linearGradient
//     id="SVGID_23_"
//     gradientUnits="userSpaceOnUse"
//     x1="836.4907"
//     y1="322.854"
//     x2="961.2872"
//     y2="97.4731"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="1.230000e-02" style={{ stopColor: '#00A5C3' }} />
//     <stop offset="1" style={{ stopColor: '#0084A9' }} />
//   </linearGradient>,
//   <polygon className="st27" points="706.4,829.2 964,680.5 964,977.9 " />,
//   <polygon className="st8" points="706.4,1126.7 964,977.9 964,1275.4 " />,
//   <linearGradient
//     id="SVGID_24_"
//     gradientUnits="userSpaceOnUse"
//     x1="448.8"
//     y1="102.06"
//     x2="706.4"
//     y2="102.06"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="1.230000e-02" style={{ stopColor: '#00A5C3' }} />
//     <stop offset="1" style={{ stopColor: '#0084A9' }} />
//   </linearGradient>,
//   <polygon className="st28" points="448.8,977.9 706.4,829.2 706.4,1126.7 " />,
//   <polygon className="st11" points="964,977.9 706.4,1126.7 706.4,829.2 " />,
//   <polygon className="st11" points="706.4,1126.7 448.8,1275.5 448.8,978 " />,
//   <linearGradient
//     id="SVGID_25_"
//     gradientUnits="userSpaceOnUse"
//     x1="1866.9521"
//     y1="322.8513"
//     x2="1991.7487"
//     y2="97.4705"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="1.230000e-02" style={{ stopColor: '#00A5C3' }} />
//     <stop offset="1" style={{ stopColor: '#0084A9' }} />
//   </linearGradient>,
//   <polygon className="st29" points="1736.9,829.2 1994.5,680.5 1994.5,977.9 " />,
//   <polygon
//     className="st8"
//     points="1736.9,1126.7 1994.5,977.9 1994.5,1275.4 "
//   />,
//   <polygon className="st4" points="1479.3,977.9 1736.9,829.2 1736.9,1126.7 " />,
//   <polygon
//     className="st11"
//     points="1994.5,977.9 1736.9,1126.7 1736.9,829.2 "
//   />,
//   <polygon className="st11" points="1736.9,1126.7 1479.3,1275.5 1479.3,978 " />,
//   <polygon className="st2" points="191.2,1126.7 -66.4,1275.4 -66.4,977.9 " />,
//   <polygon className="st2" points="191.2,829.2 -66.4,977.9 -66.4,680.5 " />,
//   <polygon className="st2" points="448.9,977.9 191.2,1126.7 191.2,829.2 " />,
//   <linearGradient
//     id="SVGID_26_"
//     gradientUnits="userSpaceOnUse"
//     x1="64.4783"
//     y1="172.5289"
//     x2="186.5993"
//     y2="-54.2716"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="1.230000e-02" style={{ stopColor: '#00A5C3' }} />
//     <stop offset="1" style={{ stopColor: '#0084A9' }} />
//   </linearGradient>,
//   <polygon className="st30" points="-66.4,977.9 191.2,829.2 191.2,1126.7 " />,
//   <linearGradient
//     id="SVGID_27_"
//     gradientUnits="userSpaceOnUse"
//     x1="318.8737"
//     y1="29.7075"
//     x2="450.9657"
//     y2="-191.4581"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="1.230000e-02" style={{ stopColor: '#00A5C3' }} />
//     <stop offset="1" style={{ stopColor: '#0084A9' }} />
//   </linearGradient>,
//   <polygon className="st31" points="191.2,1126.6 448.9,977.8 448.7,1275.3 " />,
//   <linearGradient
//     id="SVGID_28_"
//     gradientUnits="userSpaceOnUse"
//     x1="-75.813"
//     y1="1286.3083"
//     x2="62.3694"
//     y2="1068.9017"
//     gradientTransform="matrix(1 0 0 -1 0 1080)"
//   >
//     <stop offset="0" style={{ stopColor: '#78B627' }} />
//     <stop offset="1" style={{ stopColor: '#3B8B31' }} />
//   </linearGradient>,
//   <polygon className="st32" points="191.2,-63.2 -66.4,85.5 -66.4,-211.9 " />,
//   <polygon className="st4" points="1736.8,-63.2 1994.4,-211.9 1994.4,85.5 " />
// ];

class Triangles extends React.Component {
  componentDidMount() {}

  randomNumber = () => {
    return Math.floor(Math.random() * 21) - 10;
  };

  render() {
    return (
      <div
        style={{
          background: 'url(/images/hero-image-3.jpg) no-repeat 50% 50%',
          backgroundColor: '#fff',
          backgroundSize: 'cover',
          width: '100%',
          height: '100%'
        }}
      >
        {/* <svg
          version="1.1"
          id="Layer_1"
          x="0"
          y="0"

        style={{
          background: 'url(/images/hero-image-2.jpg) no-repeat center center',
          backgroundSize: 'cover',
          width: '100vw',
          height: '100vh'
        }}
          // preserveAspectRatio="xMinYMin meet"
          viewBox="0 0 1920 1080"
        xmlSpace="preserve"
        {elementsArray
        {/* .sort(() => Math.random() - 0.5)
            .map((element, index) => (
              <Tween
                to={{
                  opacity: 0,
                  transform: `scale(${1 + this.randomNumber() / 100})`
                }}
                delay={index * 0.01 + 1}
                duration={0.9}
                ease="Back.easeOut"
              >
                {element}
              </Tween>
            ))}
        </svg> */}
      </div>
    );
  }
}

export default Triangles;
